import { styled } from '@mui/material';
import { GivelifyButton } from '@givelify/ui';

export const textFieldWidth = 512;

export const Wrapper = styled('div')<{ showZip: boolean }>(
    ({ theme, showZip }) => ({
        textAlign: 'left',
        display: 'grid',
        gridTemplateAreas: `
        "orgName orgName"
        "${showZip ? 'city zip' : 'city city'}"
        "button button"
    `,
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        maxWidth: 500,
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            gridTemplateAreas: `
           "orgName"
           "city"
           ${showZip ? '"zip"' : ''}
           "button"
        `,
            gridTemplateColumns: '1fr',
        },
    }),
);

export const OrganizationName = styled('div')({
    gridArea: 'orgName',
});

export const StyledButton = styled(GivelifyButton)(({ theme }) => ({
    gridArea: 'button',
    justifySelf: 'center',
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
    },
}));
